import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import "./StartRating.css";

const StartRating = () => {
  const [rating, setRating] = useState(null);
  const [hover, setHover] = useState(null);

  return (
    <div className="mt-3">
      {[...Array(5)].map((start, i) => {
        const ratingValue = i + 1;

        return (
          <label key={i}>
            <input
              type="radio"
              name="rating"
              value={ratingValue}
              onClick={() => sessionStorage.setItem("ratingValue", ratingValue)}
              onChange={() => setRating(ratingValue)}
            />
            <FontAwesomeIcon
              color={ratingValue <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
              className="start"
              size="2x"
              icon={faStar}
              onMouseEnter={() => setHover(ratingValue)}
              onMouseLeave={() => setHover(null)}
            />
          </label>
        );
      })}
    </div>
  );
};

export default StartRating;
